import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQ_ITEMS } from "@/constants/tracks";
import { FAQ } from "@/constants/testIds";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      data-testid={FAQ.root}
      className="border-b border-[color:var(--iw-border)] bg-[color:var(--iw-bg)] py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="iw-overline mb-3">§ 08 — FAQ</div>
            <h2 className="font-display text-3xl font-semibold tracking-tight text-[color:var(--iw-primary)] sm:text-4xl lg:text-5xl">
              The real{" "}
              <span className="text-[color:var(--iw-blue)]">answers</span>.
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-xl leading-relaxed text-[color:var(--iw-body)]">
              The real questions people ask before they start.
            </p>
          </div>
        </div>

        <div className="border-y border-[color:var(--iw-border)]">
          {FAQ_ITEMS.map((item, i) => {
            const open = openIdx === i;
            return (
              <div
                key={item.q}
                data-testid={FAQ.item(i)}
                className="border-b border-[color:var(--iw-border)] last:border-b-0"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 px-1 py-6 text-left transition-colors hover:bg-white sm:px-3"
                  aria-expanded={open}
                >
                  <div className="flex items-baseline gap-5">
                    <span className="font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--iw-accent-red)]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-lg font-medium tracking-tight text-[color:var(--iw-primary)] sm:text-xl">
                      {item.q}
                    </span>
                  </div>
                  <span className="grid h-9 w-9 flex-shrink-0 place-items-center border border-[color:var(--iw-primary)] text-[color:var(--iw-primary)]">
                    {open ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </button>
                {open && (
                  <div className="iw-animate-up px-1 pb-7 pl-[3.4rem] pr-3 text-base leading-relaxed text-[color:var(--iw-body)] sm:px-3 sm:pl-[3.6rem]">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
